import {
  useCbsIntegrationEnabled,
  useCheckStateFormsEnabled,
  useClioQuestionnairesEnabled,
  useCourtFormsEnabled,
  useDraftToWorkTemplateMigrationEnabled,
  useFederalCourtFormsEnabled,
  useFederalFormsCategoriesEnabled,
  useIsCanary,
  useIsClioFree,
  useIsIdentityLoginDisabled,
  useIsMaintenanceBannerEnabled,
  useIsUnifiedPlatform,
  useMavenIntegrationEnabled,
  usePracticeAreaStandardContentEnabled,
  useWordDocumentAutomationEnabled,
} from '../entities/user';

const useFeatureAccesses = () => {
  const isClioFreePlan = useIsClioFree();
  const isUnifiedPlatform = useIsUnifiedPlatform();
  const isCourtFormsEnabled = useCourtFormsEnabled();
  const isUnifiedPlatformWithCourtFormsEnabled =
    isUnifiedPlatform && isCourtFormsEnabled;
  const doesFeatureAccessForThisStateCodeExist = useCheckStateFormsEnabled();
  const isClioQuestionnaireEnabled = useClioQuestionnairesEnabled();
  const isWordDocumentAutomationEnabled = useWordDocumentAutomationEnabled();
  const isFederalCourtFormsEnabled = useFederalCourtFormsEnabled();
  const isCanary = useIsCanary();
  const isMaintenanceBannerEnabled = useIsMaintenanceBannerEnabled();
  const isCbsIntegrationEnabled = useCbsIntegrationEnabled();
  const isIdentityLoginDisabled = useIsIdentityLoginDisabled();
  const isMavenEnabled = useMavenIntegrationEnabled();
  const isPracticeAreaStandardContentEnabled =
    usePracticeAreaStandardContentEnabled();
  const isFederalFormsCategoriesEnabled = useFederalFormsCategoriesEnabled();
  const isDraftToWorkTemplateMigrationEnabled =
    useDraftToWorkTemplateMigrationEnabled();

  return {
    isClioFreePlan,
    doesFeatureAccessForThisStateCodeExist,
    isClioQuestionnaireEnabled,
    isWordDocumentAutomationEnabled,
    isFederalCourtFormsEnabled,
    isCourtFormsEnabled,
    isUnifiedPlatform,
    isUnifiedPlatformWithCourtFormsEnabled,
    isCanary,
    isMaintenanceBannerEnabled,
    isCbsIntegrationEnabled,
    isIdentityLoginDisabled,
    isMavenEnabled,
    isPracticeAreaStandardContentEnabled,
    isFederalFormsCategoriesEnabled,
    isDraftToWorkTemplateMigrationEnabled,
  };
};

export default useFeatureAccesses;
